module.exports = __webpack_public_path__ + "img/Blanca-Ireri-.97f15086.png";